export interface CsvHeader {
  label: string;
  key: string;
}

const escapeCell = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const buildCsv = (
  headers: CsvHeader[],
  rows: Record<string, unknown>[],
): string => {
  const headerLine = headers.map((h) => escapeCell(h.label)).join(",");
  const dataLines = rows.map((row) =>
    headers.map((h) => escapeCell(row[h.key])).join(","),
  );
  return [headerLine, ...dataLines].join("\r\n");
};

// UTF-8 BOM so Excel (Windows + macOS) reads non-ASCII characters correctly.
const BOM = "﻿";

export const triggerCsvDownload = (csv: string, filename: string): void => {
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });

  const nav = window.navigator as Navigator & {
    // eslint-disable-next-line no-unused-vars
    msSaveBlob?: (blob: Blob, defaultName?: string) => boolean;
  };
  // IE / old Edge.
  if (typeof nav.msSaveBlob === "function") {
    nav.msSaveBlob(blob, filename);
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  if ("download" in link) {
    link.href = url;
    link.download = filename;
    link.rel = "noopener";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 4000);
    return;
  }

  const opened = window.open(url, "_blank");
  if (!opened) {
    window.location.href = url;
  }
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};
